/**
 * Makes page scroll to the element passed
 */

/**
 * Scrolls the screen down to an element
 * @param {string} element Pass the identifier of the element you want to scroll to, id for bets results
 */

function scrolldown(element) {
    jQuery(document).ready(function ($) {
        console.log(element);
        $('html, body').animate({
            scrollTop: $(element).offset().top
        }, 500);
    });
}